module.exports = __webpack_public_path__ + "../resources/images/SkyCode_29-a8a6b021e14279d9a55249b24b239287.svg";